export const pt = {
  locale: 'pt',
  nav: {
    setup: 'Central de Controle',
    news: 'Notícias',
    brand: 'Simulador WC26',
    teamName: 'Equipe',
    tactics: 'Tática',
    fixtures: 'Jogos',
    standings: 'Classificação',
    knockout: 'Mata-mata',
    teamStats: 'Estatísticas Equipe',
    playerStats: 'Estatísticas Jogadores',
  },
  landing: {
    title: 'Simulador da Copa do Mundo',
    subtitle: 'Do jogo de abertura à final. Escolha seu lugar como espectador ou assuma como técnico.',
    audienceMode: {
      title: 'Modo Espectador',
      subtitle: 'Visão Completa do Torneio',
      desc: 'Avance por cada partida do torneio, acompanhando notícias, classificações, chaveamentos e estatísticas.',
    },
    coachMode: {
      title: 'Modo Técnico',
      subtitle: 'Comande uma Seleção Nacional',
      desc: 'Selecione uma seleção nacional e assuma o banco. Veja seu elenco, ajuste formação, mentalidade, pressão e foco ofensivo.',
    },
    completed: 'Concluídos',
    upcoming: 'Próximos',
    championRanking: 'Simulação de Campeão',
    coachPickRanking: 'Escolhas dos Técnicos',
    noCompleted: 'Nenhuma partida concluída ainda.',
    noUpcoming: '',
    noCoachPick: 'Nenhuma escolha de modo Técnico registrada.',
    coachSetup: {
      title: 'Escolha sua Equipe e Lide-a à Glória',
      back: 'Voltar',
      start: 'Iniciar Minha Jornada',
      processing: 'Criando jornada',
      hiddenTeamsOpen: "Abrir Equipas Ocultas",
      hiddenTeamsClose: "Fechar Equipas Ocultas",
    },
    rosterInfo: 'Grupo {group} · {count} Jogadores',
    simKicker: {
      audience: 'Modo Espectador · Cobertura Total',
      coach: 'Modo Técnico · Grupo {group}',
    },
    simTitle: {
      audience: 'Central de Cobertura Total',
      coach: '{flag} Jornada de {name}',
    },
    warning: {
      leave: 'Sair perderá os dados da simulação atual.',
      confirm: 'Sair perderá os dados da simulação. Tem certeza?',
    },
    groupLabel: 'Grupo {id}',
    championCount: '{count} vezes',
    coachPickCount: '{count} escolhas',
  },
  common: {
    continue: 'Continuar',
    processing: 'Processando',
    completed: 'Concluído',
    close: 'Fechar',
    back: 'Voltar',
    vs: 'VS',
    restart: 'Nova campanha',
    restartConfirm: 'Iniciar uma nova campanha? O progresso atual e os dados salvos localmente serão apagados.',
    playAgain: 'Jogar novamente',
  },
  team: {
    tab: {
      players: 'Jogadores',
      fixtures: 'Jogos',
      tactic: 'Tática',
    },
    playerTable: {
      player: 'Jogador',
      club: 'Clube',
      status: 'Status',
      position: 'Pos',
      ability: 'Nota',
      age: 'Idade',
      caps: 'Sel',
      ntGoals: 'G sel',
      apps: 'J',
      goals: 'G',
      assists: 'A',
      rating: 'Média',
    },
    status: {
      redCard: 'Cartão Vermelho',
    },
    noTactic: 'Este time ainda não tem partidas concluídas.',
    tactic: {
      formation: 'Formação',
      mentality: 'Mentalidade',
      width: 'Largura',
      tempo: 'Ritmo',
      passing: 'Passe',
      attackRoute: 'Foco Ataque',
      transition: 'Transição',
      pressing: 'Pressão',
      defensiveLine: 'Linha Defensiva',
      possession: 'Posse',
    },
  },
  tactics: {
    formation: 'Formação',
    more: 'Mais Formações',
    roster: {
      title: 'Elenco',
      order: '#',
      status: 'Status',
      name: 'Nome',
      position: 'Pos',
      ability: 'Nota',
      apps: 'J',
      goals: 'G',
      assists: 'A',
    },
    emptySlot: 'Vago',
    noData: 'Nenhum dado tático disponível',
    benchPrefix: 'Res',
    starterPrefix: 'XI',
  },
  stats: {
    team: {
      title: 'Estatísticas Equipe',
      subtitle: 'Classificado por desempenho acumulado',
      noData: 'Nenhum dado de equipe.',
      ranking: 'Ranking',
      value: 'Valor',
      matches: 'Partidas',
    },
    player: {
      title: 'Estatísticas Jogadores',
      subtitle: 'Ranking de Jogadores',
      noData: 'Nenhum dado de jogador.',
      nationality: 'País',
      value: 'Valor',
      apps: 'Jogos',
    },
    playerTotals: {
      title: 'Totais do Elenco',
      subtitle: 'Apenas partidas concluídas.',
      noData: 'Seu time ainda não jogou.',
    },
    groups: {
      overall: 'Geral',
      form: 'Forma',
      discipline: 'Disciplina',
      attack: 'Ataque',
      creative: 'Criativo',
      goalkeeping: 'Goleiros',
    },
    items: {
      avgPossession: 'Posse Média',
      goalsFor: 'Gols Pró',
      xg: 'xG',
      shots: 'Chutes',
      formText: 'Forma',
      winStreak: 'Sequência Vitórias',
      unbeatenStreak: 'Invencibilidade',
      winlessStreak: 'Sem Vencer',
      scorelessStreak: 'Sem Marcar',
      yellowCards: 'Cartões Amarelos',
      redCards: 'Cartões Vermelhos',
      fouls: 'Faltas',
      goals: 'Gols',
      assists: 'Assistências',
      minutesPerGoal: 'Min/Gol',
      apps: 'Jogos',
      starts: 'Titular',
      averageRating: 'Nota Média',
      keyPasses: 'Passes Chave',
      passesAttempted: 'Passes',
      passCompletion: '% Passes',
      saves: 'Defesas',
    },
    descriptions: {
      avgPossession: 'Posse média em partidas concluídas',
      goalsFor: 'Total de gols marcados',
      xg: 'xG total acumulado',
      shots: 'Total de chutes',
      formText: 'Forma recente',
      winStreak: 'Vitórias consecutivas atuais',
      unbeatenStreak: 'Invencibilidade atual',
      winlessStreak: 'Sequência sem vitória',
      scorelessStreak: 'Jogos sem marcar consecutivos',
      yellowCards: 'Total cartões amarelos',
      redCards: 'Total cartões vermelhos',
      fouls: 'Total faltas',
      playerGoals: 'Artilharia',
      playerAssists: 'Assistências',
      playerXg: 'xG dos jogadores',
      playerShots: 'Chutes dos jogadores',
      minutesPerGoal: 'Minutos por gol',
      playerApps: 'Jogos dos jogadores',
      playerStarts: 'Jogos com 45+ minutos',
      playerYellowCards: 'Cartões amarelos dos jogadores',
      playerRedCards: 'Cartões vermelhos dos jogadores',
      playerAvgRating: 'Nota média',
      playerKeyPasses: 'Passes chave dos jogadores',
      playerPasses: 'Total de passes tentados',
      playerPassCompletion: 'Percentual de passes certos',
      playerSaves: 'Defesas dos goleiros',
    },
  },
  position: {
    gk: 'Goleiros',
    def: 'Defensores',
    mid: 'Meio-campistas',
    fwd: 'Atacantes',
  },
  stage: {
    'Group Stage': 'Fase de Grupos',
    'Round of 32': '32 Avos de Final',
    'Round of 16': 'Oitavas de Final',
    'Quarter-final': 'Quartas de Final',
    'Semi-final': 'Semifinal',
    'Third Place': 'Terceiro Lugar',
    'Final': 'Final',
  },
  match: {
    penaltyMarker: 'P',
    extraTimeMarker: 'PR',
    penalty: {
      scored: 'Marcado',
      missed: 'Perdido',
    },
    status: {
      finished: 'Finalizado',
      notStarted: 'Não Iniciado',
      pending: 'Pendente',
    },
    viewDetail: 'Ver Detalhes',
    modal: {
      teamData: 'Dados Equipe',
      playerData: 'Dados Jogadores',
      finalResult: 'Resultado Final',
      restart: 'Jogar Novamente',
      subtitle: {
        extra: 'T.R. {normal}, P.R. {extra}.',
        penalty: 'T.R. {normal}, P.R. {extra}, Pên. {penalty}, {winner} avança.',
      },
    },
    shootout: 'Disputa de Pênaltis',
    extraTime: 'Prorrogação',
    decision: {
      penalty: ' · Pên. {home}-{away}',
      extra: ' · P.R. {home}-{away}',
    },
    news: {
      penalty: 'A partida terminou {normal} no tempo regulamentar e {extra} na prorrogação; {winner} venceu {penalty} nos pênaltis.',
      extraTime: 'A partida terminou {normal} no tempo regulamentar, com {goals} gols a mais na prorrogação. Placar final: {final}.',
    },
    fallback: '{home} e {away} terminaram {score} na {stage}.',
    eventsFallback: 'A partida foi decidida no meio-campo e nos detalhes defensivos.',
    xg: 'xG {home}/{away}',
    possession: 'Posse {home}/{away}',
    shots: 'Chutes {home}/{away}',
    best: 'Melhor {player}',
    simulate: 'Simular',
    simTitle: 'Resultados da simulação',
    simulating: 'Simulando…',
    simProgress: '10 simulações para esta partida',
  },
  fixture: {
    title: 'Jogos',
    noDate: 'Sem Rodada',
    prevDay: 'Rodada anterior',
    nextDay: 'Próxima rodada',
  },
  knockout: {
    title: 'Mata-mata',
    subtitle: 'O caminho dos 32 avos à Final',
    tabs: {
      bracket: 'Chaveamento',
    },
    stageNotGenerated: 'Esta fase ainda não foi gerada.',
    tbd: 'TBD',
  },
  standings: {
    rank: 'Pos',
    team: 'Equipe',
    played: 'J',
    wins: 'V',
    draws: 'E',
    losses: 'D',
    goalsFor: 'GP',
    goalsAgainst: 'GC',
    goalDiff: 'SG',
    points: 'Pts',
    filter: 'Filtrar',
  },
  tacticsControls: {
    mentality: {
      label: 'Mentalidade',
      options: ['Ataque Total', 'Atacar', 'Positivo', 'Equilibrado', 'Cauteloso', 'Defensivo', 'Defesa Total'],
    },
    width: {
      label: 'Largura',
      options: ['Estreito', 'Rel. Estreito', 'Normal', 'Rel. Largo', 'Largo'],
    },
    tempo: {
      label: 'Ritmo',
      options: ['Lento', 'Rel. Lento', 'Normal', 'Rel. Rápido', 'Rápido'],
    },
    passing: {
      label: 'Passe',
      options: ['Bola Longa', 'Direto', 'Misto', 'Curto', 'Muito Curto'],
    },
    attackRoute: {
      label: 'Foco Ataque',
      options: ['Pelos Lados', 'Misto', 'Central'],
    },
    transition: {
      label: 'Transição',
      options: ['Sair Jogando', 'Construir Atrás', 'Misto', 'Rápido ao Meio', 'Rápido ao Ataque'],
    },
    defensiveLine: {
      label: 'Linha Defensiva',
      options: ['Baixa', 'Média', 'Alta'],
    },
    pressing: {
      label: 'Pressão',
      options: ['Baixa', 'Média', 'Alta'],
    },
    possession: {
      label: 'Posse',
      options: ['Recuar', 'Menos Posse', 'Equilibrado', 'Mais Posse', 'Controle Total'],
    },
  },
  formations: {
    '4-2-3-1A': '4 defs, 2 MD, 2 pontas, 1 ME, 1 atacante',
    '4-2-3-1S': '4 defs, 2 MD, 1 MC, 2 pontas, 1 atacante',
    '4-3-3': '4 defs, 3 meias, 3 atacantes',
    '4-1-4-1': '4 defs, 1 MD, 4 meias em linha, 1 atacante',
    '4-1-2-2-1': '4 defs, 1 MD, 2 MC, 2 pontas, 1 atacante',
    '4-3-1-2M': '4 defs, 3 MC, 1 ME, 2 atacantes',
    '4-3-1-2D': '4 defs, 3 MD, 1 MC, 2 atacantes',
    '4-3-2-1M': '4 defs, 3 MC, 2 ME, 1 atacante',
    '4-3-2-1D': '4 defs, 3 MD, 2 MC, 1 atacante',
    '4-3-2-1S': '4 defs, 3 MC, 2 pontas, 1 atacante',
    '4-4-1-1': '4 defs, 4 meias em linha, 1 ME, 1 atacante',
    '4-2-2-2': '4 defs, 2 MD, 2 pontas, 2 atacantes',
    '4-4-2F': '4 defs, 4 meias em linha, 2 atacantes',
    '4-4-2D': '4 defs, losango no meio, 2 atacantes',
    '3-3-2-2': '3 ZG, 2 laterais, 1 MD, 2 MC, 2 atacantes',
    '3-2-4-1': '3 ZG, 2 MD, 2 abertos, 2 MC, 1 atacante',
    '3-2-2-2-1': '3 ZG, 2 laterais, 2 MC, 2 pontas, 1 atacante',
    '3-2-3-2D': '3 ZG, 2 MD, 2 abertos, 1 MC, 2 atacantes',
    '3-2-3-2W': '3 ZG, 2 laterais, 3 MC, 2 atacantes',
    '3-4-1-2': '3 ZG, 2 laterais, 2 MD, 1 ME, 2 atacantes',
    '3-4-2-1S': '3 ZG, 2 laterais, 2 MD, 2 pontas, 1 atacante',
    '3-4-2-1C': '3 ZG, 2 laterais, 2 MD, 2 ME, 1 atacante',
    '3-4-3F': '3 ZG, 4 meias em linha, 3 atacantes',
    '3-4-3D': '3 ZG, losango no meio, 3 atacantes',
    '5-3-2': '5 defs, 3 MC, 2 atacantes',
    '5-4-1F': '5 defs, 4 meias em linha, 1 atacante',
    '5-4-1D': '5 defs, losango no meio, 1 atacante',
    '5-2-2-1': '5 defs, 2 MD, 2 pontas, 1 atacante',
  },
  news: {
    title: 'Notícias',
    subtitle: 'Atualizações das partidas',
    titleTexts: {
      groupRecap: 'Resumo da Fase de Grupos: Classificados, Surpresas e Classificações',
      knockoutRecap: 'Resumo {stage}: Classificados e Pontos de Virada',
      stagePreview: 'Prévia {stage}: Confrontos Chave e Previsões',
      championRoad: 'A Trajetória de {flag} {name} até a Glória',
      awards: 'Prêmios da Copa: Melhor Jogador, Artilheiro e Melhor Goleiro',
      review: 'Balanço da Copa: Campeão, Zebras, Placar Elástico e Heróis',
      coachSummary: 'Resumo da Campanha de {team}',
    },
    kicker: {
      author: 'Mensagem do Autor',
      guide: 'Guia Rápido',
      welcome: {
        coach: 'Bem-vindo ao Banco',
        audience: 'Bem-vindo ao Centro',
      },
      stageRecap: 'Resumo · {stage}',
      stagePreview: 'Prévia · {stage}',
      champion: 'História do Campeão',
      awards: 'Prêmios',
      tournamentReview: 'Balanço do Torneio',
      pregame: 'Pré-jogo',
      coachSummary: 'Resumo da Campanha',
    },
    default: {
      title: 'Simulação não iniciada',
      body: 'Assim que escolher um modo, as notícias começarão.',
    },
    guide: {
      title: 'Continuar primeiro leva você às notícias, depois avança o dia de jogo',
      body: 'O botão {Continuar} está no canto superior direito da página. No modo Espectador, notícias não lidas aparecem primeiro. Depois de lê-las, você verá os jogos do dia. Clique em {Continuar} novamente para simular os jogos.',
    },
    author: {
      title: 'Uma (grande) nota de agradecimento do autor',
      body: 'Obrigado por aturar o gosto estético de um programador que virou noites programando. Se a simulação te deixou feliz, elogie o autor; se o resultado foi uma zebra… bem, essa é a beleza do futebol! Para qualquer feedback, me encontre em x.com/diysimon ou Xiaohongshu (diysimon).',
    },
    finalThanks: {
      title: 'Torneio Concluído — Obrigado por Jogar!',
      body: 'A Copa do Mundo de 2026 chegou ao fim. Obrigado por vivenciar esta simulação! Siga o autor (X @diysimon / Xiaohongshu diysimon) para atualizações, feedback e futuros projetos. Fique à vontade para iniciar uma nova campanha e tentar um caminho diferente!',
    },
    coachSummary: {
      intro: 'Sua jornada com {team} chegou ao fim. A equipe terminou como {position}.',
      record: 'Ao longo do torneio, {team} obteve {wins} vitórias, {draws} empates, {losses} derrotas, marcando {goalsFor} gols e sofrendo {goalsAgainst}.',
      position: '{team} terminou em {position} lugar.',
      exit: 'Foi eliminada na {stage} pelo(a) {opponent}.',
      exitNone: 'Terminou o torneio invicta em jogos de mata-mata.',
      topScorer: 'Artilheiro: {name} com {goals} gol(is).',
      noScorer: 'Nenhum jogador se destacou na artilharia.',
      bestWin: 'Maior vitória: {match}.',
      meta: '{wins}V {draws}E {losses}D | {goalsFor}GP {goalsAgainst}GC | {position}',
      factRecord: 'Campanha: {wins}V {draws}E {losses}D',
      factGoals: 'Gols: {goalsFor} Pró / {goalsAgainst} Contra (dif {diff})',
      factTopScorer: 'Artilheiro: {name} ({goals} gols)',
      factChampion: '{team} é Campeã Mundial!',
      factFinish: 'Posição final: {position}',
      positions: {
        champion: 'Campeã',
        runnerUp: 'Vice-campeã',
        semiFinal: 'Semifinalista',
        quarterFinal: 'Quartas de final',
        round16: 'Oitavas de final',
        round32: '32 avos de final',
        groupStage: 'Fase de Grupos',
      },
    },
    welcome: {
      coach: {
        title: '{flag} {name} inicia sua jornada',
        body: 'Você assumiu o comando de {name}. Use o menu esquerdo para ver elenco, tática, jogos e estatísticas.',
      },
      audience: {
        title: 'Simulação Copa do Mundo 2026 carregada',
        body: 'Você está assistindo ao torneio como espectador. O sistema avança jogo a jogo.',
      },
    },
    facts: {
      thanks: 'Obrigado por jogar',
      feedback: 'Feedback bem-vindo',
      entertainment: 'Simulação apenas para entretenimento',
      newsFirst: 'Notícias mais recentes primeiro',
      fixtureBrowse: 'Jogos por rodada',
      resultsGenerate: 'Resultados geram notícias',
      newsUpdates: 'Notícias atualizadas ao vivo',
      timeline: 'Linha do tempo mostra próximos jogos',
      refreshWarning: 'Recarregar ou sair perde a simulação',
      operation: 'Como jogar',
      preMatch: 'Informe pré-jogo',
    },
    narrative: {
      intro: {
        penalty: '{winner} venceu nos pênaltis por {score} após uma disputa acirrada na {stage}.',
        extraTime: '{winner} venceu por {winnerScore} na prorrogação para garantir uma vitória suada na {stage}.',
        win: [
          '{winner} controlou o ritmo na {stage} e garantiu uma vitória por {score}.',
          '{winner} superou o adversário com um jogo sólido nos dois lados do campo, fechando em {score} na {stage}.',
          '{winner} aproveitou os momentos decisivos neste confronto de {stage}, terminando em {score}.',
          '{winner} não desperdiçou as oportunidades na {stage}, fechando com uma vitória por {score}.',
          'A {stage} foi muito disputada do início ao fim, mas o gol decisivo de {winner} fechou em {score}.',
        ],
        draw: [
          'Uma {stage} tensa terminou empatada, com {home} e {away} fechando em {score}.',
          '{home} e {away} trocaram golpes na {stage}, mas nenhum conseguiu a vitória — {score} foi o placar final.',
          'A {stage} terminou sem vencedor: {home} e {away} dividiram os pontos em {score}.',
        ],
      },
      noEvent: [
        'Nenhum dos lados conseguiu uma vantagem decisiva. A partida foi marcada por batalhas no meio-campo e bloqueios no terço final.',
        'Ambas as defesas se mantiveram bem postadas, deixando poucas oportunidades reais de gol.',
        'A finalização foi o tema da partida — jogadas promissoras constantemente falhavam no último momento.',
      ],
      goal: {
        extraTime: [
          '{minute}, a prorrogação chegou à sua fase crítica. {scorer} aproveitou o passe de {assister} e {method} para fazer {score}.',
          '{minute}, {team} aproveitou sua chance na prorrogação quando {scorer} {method} passando pelo goleiro, {team} {state}.',
          '{minute}, com as pernas cansadas e espaços se abrindo, {scorer} {method} calmamente para colocar a bola na rede, fazendo {score}.',
          '{minute}, {scorer} entregou o momento decisivo da prorrogação, {method} para colocar {team} de volta ao controle.',
        ],
        withAssist: [
          '{minute}, {scorer} completou o cruzamento de {assister} pela direita, {method} à frente do defensor para fazer {score}, {team} {state}.',
          '{minute}, {assister} enfiou um passe decisivo, {scorer} se antecipou e {method}, {team} {state}.',
          '{minute}, {team} trabalhou uma bela combinação. {assister} rolou para {scorer}, que {method} para fazer {score}.',
          '{minute}, {scorer} se beneficiou do passe de {assister}, {method} passando pelo goleiro indefeso, {team} {state}.',
          '{minute}, {assister} fez um passe que quebrou as linhas, {scorer} dominou na corrida e {method} para marcar — {score}.',
          '{minute}, {team} recuperou a bola no campo ofensivo e jogou rápido. {assister} rolou para {scorer}, que {method}.',
          '{minute}, {assister} cobriu a bola parada na área. {scorer} subiu mais alto que a marcação e {method}, {team} {state}.',
          '{minute}, {scorer} encontrou o passe de {assister} e {method} de primeira — a jogada resultou em {score}.',
          '{minute}, {assister} atraiu defensores antes de rolar a bola. {scorer} encontrou espaço e {method}, {team} {state}.',
          '{minute}, {team} moveu a bola com paciência até a brecha aparecer. {assister} fez o passe final e {scorer} {method}.',
        ],
        solo: [
          '{minute}, {scorer} se livrou de um marcador na entrada da área e {method}, {team} {state} — {score}.',
          '{minute}, {scorer} aproveitou um afastamento mal feito e {method} para o gol vazio.',
          '{minute}, {scorer} partiu do meio-campo até a entrada da área e soltou um {method} no fundo da rede.',
          '{minute}, a pressão alta de {team} causou confusão. {scorer} foi o mais rápido a reagir, {method} para fazer {score}.',
          '{minute}, {scorer} reagiu primeiro no bate-bola, {method} de perto, {team} {state}.',
        ],
        methodHigh: ['cabeceou', 'empurrou', 'encobriu o goleiro', 'girou e finalizou de perto'],
        methodLow: ['chute de longe', 'finalização colocada', 'chute de fora da área', 'voleio'],
        methodMid: ['bateu', 'encaixou', 'mandou para o fundo da rede', 'finalização calma', 'finalizou cruzado'],
      },
      chance: [
        '{minute}, {team} quase {chanceState}. {player} ficou cara a cara com o goleiro, mas ele levou a melhor.',
        '{minute}, {player} teve uma chance de ouro dentro da área, mas colocou para fora no último instante.',
        '{minute}, {team} saiu rapidamente no contra-ataque, mas a finalização de {player} passou rente à trave.',
        '{minute}, {player} encontrou o cruzamento com boa movimentação, mas não conseguiu direcionar ao gol.',
      ],
      redCard: [
        '{minute}, {team} sofreu um golpe com a expulsão de {player}, mudando o rumo da partida.',
        '{minute}, {player} foi expulso, forçando {team} a se fechar para o resto do jogo.',
        '{minute}, o árbitro mostrou o vermelho para {player}. O plano de jogo de {team} teve que mudar na hora.',
      ],
      flow: {
        xgGap: '{dominant} criou as melhores chances, liderando em xG por {xgHome}-{xgAway} e em chutes por {shotsHome}-{shotsAway}.',
        possession: '{controller} dominou a posse de bola com {possession}%, mas a eficiência na área foi mais importante.',
        balanced: 'A diferença de qualidade nas chances foi pequena ({xgHome}-{xgAway} xG), com a partida decidida nas transições e na execução final.',
      },
      tactic: {
        control: [
          'Taticamente, {controller} ditou o ritmo, mantendo a bola com passes pacientes e {possession}% de posse.',
          'O plano de {controller} era claro: segurar a bola, explorar os lados e meios-espaços, e impedir que {away} criasse ritmo.',
          '{controller} usou a posse sustentada para enfraquecer a pressão adversária, mantendo o jogo em seu controle.',
          '{controller} se manteve compacto e paciente com a bola, transformando a retenção em mais tempo no terço final.',
        ],
        direct: [
          '{direct} não buscou a posse — priorizou colocar a bola na área rapidamente, e mais chutes refletiram essa abordagem.',
          'No ataque, {creator} foi mais incisivo em encontrar áreas perigosas, e sua vantagem em passes chave manteve a defesa sob pressão.',
          '{direct} moveu a bola com propósito, evitando o congestionamento do meio-campo e levando o jogo direto ao gol.',
          '{creator} mostrou maior variedade no terço final — cruzamentos, enfiadas e disputas de segunda bola geraram ameaças reais.',
        ],
        pressure: [
          '{presser} teve um trabalho imenso sem a bola, dificultando a saída limpa do adversário.',
          'A disciplina defensiva de {presser} se destacou — os meias voltaram rápido e sufocaram o perigo antes da área.',
          'A intensidade física foi alta. {presser} cortou as linhas de passe com pressão implacável e coberturas.',
          '{presser} foi agressivo na recuperação da bola após perdê-la — nem sempre gerando chutes, mas sufocando contra-ataques.',
        ],
        balanced: [
          'Ambos os lados foram cautelosos na execução, mantendo compactação e deixando o jogo ser decidido em duelos e segundas bolas.',
          'Não foi um jogo aberto. Nenhum dos lados abandonou sua estrutura defensiva, confiando em passes chave para furar o bloqueio.',
          'Ambas as equipes administraram o risco com cuidado, limitando o avanço ofensivo. O jogo foi definido por alguns momentos de qualidade.',
          'Taticamente, os lados se anularam: um tentou acelerar, o outro obstruiu os espaços centrais.',
          'As batalhas no meio-campo interromperam repetidamente o ritmo, mostrando que ambos priorizavam as transições defensivas.',
        ],
      },
      coach: {
        late: [
          'A paciência da comissão técnica compensou. {winner} não se precipitou no segundo tempo, esperando o cansaço do adversário para dar o golpe decisivo.',
          'As substituições e a estrutura de {winner} se mantiveram sincronizadas, permitindo pressão sustentada no fim — sinal de boa gestão de jogo.',
          '{winner} manteve a forma no impasse. O gol no fim foi resultado natural da pressão constante, não de desespero.',
          'A comissão de {winner} optou por seguir pressionando na fase final, uma decisão que rendeu o momento decisivo.',
        ],
        red: [
          'Após o cartão vermelho, a comissão de {redTeam} ajustou a formação, contando com um bloco compacto e saídas rápidas para seguir no jogo.',
          '{opponent} tentou esticar o jogo com um homem a mais, mas a resposta compacta de {redTeam} impediu que a partida escapasse.',
          'Jogar com um a menos testou a adaptabilidade de {redTeam}. Eles reduziram passes arriscados no meio e priorizaram a solidez defensiva.',
          'A comissão de {opponent} pediu movimentação mais rápida da bola após a expulsão, tentando transformar a vantagem numérica em superioridade pelos lados.',
        ],
        narrow: [
          'A comissão de {winner} foi pragmática — após abrir vantagem, não buscaram mais gols, mas protegeram o placar com posicionamento sólido.',
          '{winner} priorizou o controle após marcar, reduzindo riscos desnecessários e mantendo o jogo administrável.',
          '{winner} venceu sem extravagância. A gestão de risco da comissão foi precisa, dando poucas chances a {loser} de reagir.',
          'A vitória refletiu a abordagem realista de {winner}: garantir a defesa primeiro, depois deixar os atacantes decidirem o jogo.',
        ],
        win: [
          '{winner} executou bem o plano de jogo, mantendo a estrutura ofensiva mesmo depois de abrir vantagem.',
          '{winner} se posicionou de forma inteligente nas transições. A comissão claramente exigiu pressão imediata na bola após perdê-la.',
          'A vitória de {winner} não foi só por qualidade individual — a forma e a proteção de segunda bola sustentaram o placar.',
          '{winner} mostrou gestão madura de jogo, sabendo quando pressionar e quando segurar a bola.',
        ],
        draw: [
          'Nenhuma comissão técnica assumiu riscos totais no empate. Substituições tardias e posicionamento tenderam a evitar a derrota.',
          'Ambos tentaram criar pelas pontas, mas a defesa central nunca foi consistentemente rompida.',
          'O empate refletiu a cautela dos dois técnicos: a intenção ofensiva existia, mas nenhum se comprometeu totalmente ao ataque.',
          'Ambas as equipes reforçaram a proteção ao meio-campo nos minutos finais, mais preocupadas com um contra-ataque decidindo o jogo.',
        ],
      },
      player: {
        goals: [
          '{player} foi o nome de destaque, mudando o jogo com múltiplas finalizações e recebendo nota {rating}.',
          'O instinto de finalização de {player} decidiu a partida — seus deslocamentos encontraram consistentemente os espaços mais difíceis de defender.',
          'O ataque de {team} foi finalizado por {player}, cuja calma no chute manteve a defesa adversária sob pressão constante.',
          '{player} foi o diferencial, transformando chances em pressão real no placar.',
        ],
        attack: [
          '{player} foi influente nos momentos-chave. Além de gols e assistências, seu jogo de ligação manteve {team} avançando.',
          'A contribuição de {player} foi além dos números — ele aparecia onde o ataque precisava de um ponto de apoio.',
          '{player} aproveitou sua janela nesta partida, tomando as decisões cruciais que deram ao ataque de {team} um foco.',
          '{player} foi decisivo no terço final — sabendo quando passar e quando chutar, uma válvula de escape confiável para {team}.',
          'A movimentação de {player} criou espaços, e seu envolvimento direto mudou o ímpeto da partida.',
        ],
        saves: [
          'O trabalho de {player} no gol foi vital. Múltiplas defesas mantiveram {team} na disputa.',
          'O goleiro {player} merece menção especial, fazendo defesa atrás de defesa para negar o adversário.',
          '{team} resistiu à pressão graças aos reflexos de {player} — suas defesas foram um fator-chave.',
          '{player} teve pouca margem para erro, mas lidou com tudo com segurança, mantendo a calma mesmo em finalizações de perto.',
        ],
        create: [
          '{player} foi o elo mais importante de {team} no terço final, criando oportunidades de chute para os companheiros com passes chave.',
          'A visão de {player} moldou os padrões ofensivos de {team} — ele consistentemente encontrou linhas de passe em áreas congestionadas.',
          '{team} precisava de alguém para colocar a bola em zonas perigosas, e {player} preencheu esse papel perfeitamente.',
          '{player} não buscou só gols — usou passes para colocar os companheiros em melhores posições de finalização.',
        ],
        defense: [
          '{player} cobriu um enorme espaço defensivamente, com desarmes e interceptações que solidificaram a proteção do meio-campo de {team}.',
          '{team} limitou o avanço adversário graças à recomposição e antecipação de {player}.',
          'O valor de {player} veio sem a bola, desmontando repetidamente as investidas adversárias antes que se desenvolvessem.',
          '{player} merece reconhecimento pelo trabalho defensivo, salvando {team} de diversas situações perigosas ao redor da área.',
        ],
        shots: [
          '{player} não converteu suas chances em gols, mas os chutes constantes mantiveram a defesa adversária alerta.',
          'Grande parte da ameaça ofensiva de {team} veio de {player}, que tentou romper com finalizações.',
          'A agressividade de {player} foi notável — múltiplos chutes mostraram que ele consistentemente encontrava espaço no terço final.',
          '{player} não ficou longe do gol — seus esforços já forçaram o goleiro adversário a ficar em alerta máximo.',
        ],
        general: [
          '{player} recebeu uma das maiores notas, proporcionando jogo consistente em ambos os lados do campo para {team}.',
          'Os números de {player} não contam toda a história — seu envolvimento foi crucial para manter {team} no ritmo.',
          'O desempenho versátil de {player} foi o mais reconhecido, tomando a decisão certa em múltiplas situações.',
          'O valor de {player} estava na confiabilidade — raramente desperdiçando posse e sempre disponível para o trabalho defensivo.',
        ],
      },
      impact: {
        finalWin: '{winner} venceu a final e levantou a taça da Copa do Mundo. A jornada de {loser} terminou a um passo.',
        thirdPlace: '{winner} terminou em terceiro lugar na Copa do Mundo, enquanto {loser} ficou em quarto.',
        semiFinal: '{winner} avançou à final com esta vitória, acabando com as esperanças de {loser} de levantar a taça.',
        quarterFinal: '{winner} chegou às semifinais, agora a uma vitória da final.',
        knockoutWin: '{winner} avança no mata-mata, enquanto {loser} está eliminado.',
        placementBothDark: 'Ambas as equipes superaram amplamente as expectativas pré-torneio — a disputa de terceiro lugar foi em si uma história de zebra.',
        placementThirdDark: '{thirdName} subiu ao pódio vindo de fora do top 20 nas odds pré-torneio, superando todas as expectativas.',
        placementFourthDark: '{fourthName} perdeu esta partida, mas chegar às semifinais já superou as expectativas pré-torneio.',
        placementBothFavored: 'Ambas as equipes estão entre as 20 melhores nas odds pré-torneio, e chegar às semifinais correspondeu amplamente às expectativas.',
        groupLead: '{teamName} tem {points} pontos em {played} jogos de grupo, ocupando a {rank} posição e em boa situação para se classificar.',
        groupEliminated: '{teamName} tem apenas {points} pontos em {played} jogos, ocupando a {rank} posição e sem chances de avançar.',
        groupUpdate: 'Após esta partida, {teamName} tem {points} pontos, atualmente em {rank} no Grupo {group}.',
        groupQualifiers: 'Grupo {groupId}: {names}',
        qualified: 'classificado',
        eliminated: 'eliminado',
        favoriteStatus: '{name} {status}',
        darkHorses: '{names} são as zebras mais notáveis desta fase, superando expectativas em pontos, saldo de gols ou partidas-chave.',
        noDarkHorses: 'No geral, os favoritos mantiveram suas posições — as classificações não tiveram grandes reviravoltas.',
        unbeaten: '{names} seguem invictos, mostrando consistência impressionante.',
        scorers: 'Individualmente, {scorerLine}. {assisterLine}.{ratingLine}',
        scorerLead: '{name} lidera a artilharia com {goals} gols',
        scorerDisperse: 'A corrida pela artilharia segue aberta',
        assisterLead: '{name} lidera em assistências com {assists}',
        assisterDisperse: 'A tabela de assistências ainda é muito disputada',
        ratingHighlight: ' {name} tem média {rating} — um dos jogadores mais destacados da fase de grupos.',
      },
      recap: {
        groupIntro: [
          'A fase de grupos terminou. 32 equipes avançaram e a Copa do Mundo entra no mata-mata.',
          '72 partidas de grupo foram disputadas. Os classificados, surpresas e líderes individuais já se definiram.',
          'Fase de grupos encerrada. A consistência dos favoritos, as zebras e a corrida pela artilharia marcaram esta fase.',
        ],
        knockoutIntro: 'A {stage} terminou. {count} equipes seguem na disputa pelo título.',
        knockoutWinners: '{names} garantiram vaga na próxima fase.',
        knockoutTight: '{count} partidas foram decididas por um gol de diferença ou nos pênaltis — a tensão do mata-mata aumenta.',
        knockoutClear: 'Os resultados desta rodada foram relativamente claros, com os vencedores mostrando maior controle.',
        knockoutBiggest: 'A partida mais aberta da rodada foi {match}, com {goals} gols no total.',
        knockoutUpset: 'A zebra veio com {winner} vencendo {loser} — a equipe de menor ranking produziu a atuação mais eficiente.',
        knockoutScorers: 'Individualmente, {scorerLine}; {ratingLine}',
        knockoutScorerLead: '{name} ainda lidera a artilharia com {goals} gols',
        knockoutScorerDisperse: 'A corrida pela artilharia segue em aberto',
        knockoutRating: '{name} mantém uma nota alta, uma das estrelas mais consistentes do mata-mata.',
        knockoutRatingGeneric: 'A forma dos principais jogadores começa a definir a disputa pelo título.',
        groupLines: 'Classificados por grupo: {lines}. {favorites}',
        groupFavorites: 'Entre os favoritos, {status}.',
        groupQualifierFormat: 'Grupo {groupId}: {names}',
        groupMeta: '{count} classificados · {scorerInfo}',
        scorerInfo: 'Artilheiro {name}',
        scorerInfoUpdate: 'Estatísticas atualizadas',
        factQualified: '{count} classificados',
        factDarkHorses: 'Zebras {names}',
        factStable: 'Favoritos estáveis',
        factTopScorer: 'Artilheiro {name} {goals}G',
        factTopAssister: 'Líder assistências {name} {assists}A',
        knockoutMeta: '{count} avançaram · {tight} apertados',
        factKnockoutTight: '{count} jogos apertados',
        factKnockoutClear: 'Resultados claros',
        factUpset: 'Zebra {winner}',
        factOpen: '{goals} gols',
      },
      preview: {
        intro: 'Os confrontos da {stage} estão definidos. A próxima fase reduzirá o campo em {count} partidas.',
        keyMatch: 'Confrontos para ficar de olho: {matches}.',
        noKeyMatch: 'Nenhum confronto direto entre equipes do top 20 de odds nesta fase — os favoritos devem evitar tropeços em duelos aparentemente favoráveis.',
        favorites: 'Com base na forma e na força do elenco, {names} são favoritos a avançar.',
        noFavorites: 'A diferença nesta rodada é pequena — forma e finalização podem importar mais que a reputação.',
        tail: [
          'No mata-mata, gestão de jogo, defesa de bola parada e forma do goleiro se tornam críticos. Um erro pode redefinir todo o chaveamento.',
          'Esta fase não é só sobre poder ofensivo. O timing das substituições, gestão de risco e preparação para pênaltis influenciarão os resultados.',
          'Os favoritos devem evitar começos lentos, enquanto as zebras buscam levar o jogo para sua zona de conforto. Os primeiros 30 minutos ditarão o tom.',
        ],
        previewMeta: '{count} partidas',
        factMatchup: '{count} confrontos',
        factFocus: 'Foco {matchup}',
        factFavorite: 'Favorecido {name}',
      },
      champion: {
        road: 'A trajetória de {champion} até a glória está completa: {count} partidas, {wins} vitórias, {draws} empates, {goalsFor} gols marcados, {goalsAgainst} sofridos.',
        groupPath: 'Na fase de grupos, {champion} garantiu a classificação cedo: {matches}.',
        knockoutPath: 'No mata-mata, superou {opponents}.',
        signatureMatch: '{match} foi a atuação que definiu sua campanha.',
        meta: '{wins}V{draws}E · {goalsFor}-{goalsAgainst}',
        drawsText: '{draws}E',
        fact: 'Campeã {champion}',
        factGoal: 'Gols {goalsFor}',
        factConcede: 'Sofridos {goalsAgainst}',
        factSignature: 'Decisiva {match}',
        tail: [
          'A característica que definiu esta campeã foi a estabilidade: controlando jogos quando em vantagem e encontrando novas saídas ofensivas quando atrás ou travada.',
          'Seu título não foi construído em um lampejo — veio da solidez defensiva, produção consistente dos principais jogadores e gestão afiada.',
          'O que diferenciou a campeã foi nunca ter sido quebrada por um mau resultado, lidando com cada fase do mata-mata com compostura.',
        ],
      },
      awards: {
        intro: 'Com o fim da final, os prêmios individuais da Copa do Mundo foram definidos. {bestPlayer}',
        bestPlayer: '{name} conquistou o prêmio de Melhor Jogador com notas consistentemente altas e atuações decisivas.',
        noBestPlayer: 'A disputa pelo prêmio de Melhor Jogador foi extremamente acirrada, com múltiplos astros produzindo exibições de classe mundial.',
        topScorer: 'A Chuteira de Ouro vai para {name} com {goals} gols — o finalizador mais confiável do torneio.',
        noTopScorer: 'A artilharia não teve um líder isolado, mas a eficiência dos atacantes ainda decidiu muitas partidas.',
        topAssister: 'Nas assistências, {name} liderou com {assists} — seus passes mudaram diretamente múltiplas partidas.',
        bestKeeper: 'O prêmio de Melhor Goleiro vai para {name}, com {saves} defesas e uma média de {conceded} gols sofridos por partida.',
        noBestKeeper: 'A disputa de goleiros ficou concentrada entre alguns nomes consistentes na fase de mata-mata.',
        scorerFallback: 'o líder da artilharia',
        keeperFallback: 'um dos melhores goleiros',
        summary: '{names} formaram a narrativa individual deste torneio — um criou, um finalizou e um segurou as pontas.',
        noSummary: 'As atuações individuais estiveram fortemente ligadas aos sistemas de equipe, moldadas por estruturas táticas tanto quanto pela qualidade pessoal.',
      },
      review: {
        intro: 'O torneio terminou. {total} partidas produziram {goals} gols, uma média de {average} por jogo.',
        scoring: '{highScoring} partidas tiveram 4+ gols, e {btts} viram ambos os times marcarem. {biggest}',
        biggest: 'A partida mais aberta foi {match}.',
        upsetSep: 'venceu',
        assisterFallback: 'múltiplos criadores',
        ratingFallback: 'jogadores-chave',
        upsets: 'As zebras incluem {upsets}.',
        noUpsets: 'No geral, os favoritos confirmaram sua vantagem no papel, embora os duelos de mata-mata tenham sido frequentemente definidos por detalhes.',
        champion: 'No fim, {champion} foi quem manteve a calma por mais tempo, tornando-se a história definidora do torneio.',
        leaders: 'Individualmente, a finalização de {scorer}, a criatividade de {creators} e as altas notas de {ratings} formaram a espinha dorsal estatística do torneio.',
        noLeaders: 'Este torneio teve tanto domínio quanto surpresa — as histórias reais foram mais ricas que qualquer estatística isolada.',
        awardsMeta: 'Melhor Jogador {name}',
        awardsMetaDefault: 'Visão geral dos prêmios',
        factBestPlayer: 'Melhor Jogador {name}',
        factTopScorer: 'Artilheiro {name} {goals}G',
        factBestKeeper: 'Melhor Goleiro {name}',
        factTopAssister: 'Líder assistências {name} {assists}A',
        reviewMeta: '{count} jogos · {goals} gols',
        factTotalGoals: 'Total gols {goals}',
        factAvgGoals: 'Média {average} por jogo',
        factHighScoring: '{count} com 4+ gols',
        factBothScored: '{count} ambos marcaram',
      },
    },
  },
  helpers: {
    formText: { W: 'V', D: 'E', L: 'D' },
    goalState: {
      equalize: 'empatar',
      lead: 'abrir vantagem',
      extend: 'ampliar vantagem',
      chase: 'diminuir o placar',
    },
    chanceState: {
      extend: 'ampliar vantagem',
      break: 'abrir o placar',
      face: 'salvar a honra',
      close: 'reduzir a diferença',
    },
    tacticSummary: 'Mentalidade {mentality} · Jogo {focus} · Pressão {pressing} · Linha {line}',
    teamMate: 'um companheiro',
    attacker: 'um atacante',
    defender: 'um defensor',
    advance: ' avançou',
    groupLeader: 'Grupo {group}: líder {teamName}, {points} pts',
    unknownPlayer: 'Jogador desconhecido',
    unsolved: 'N/D',
    minute: '{minute}\'{stoppage}',
    stoppageTime: '+{minute}',
  },
  rendering: {
    playerTotals: {
      headers: ['Jogador', 'Pos', 'J', 'Min', 'G', 'A', 'xG', 'Ch', 'CD', 'Pas', 'Cmp', 'PC', 'Des', 'Int', 'CA', 'CV', 'Def', 'Nota'],
    },
    matchStats: {
      shotsOnTarget: 'Chutes no Alvo',
      passes: 'Passes',
      passSuccess: '% Passes',
      keyPasses: 'Passes Chave',
      corners: 'Escanteios',
      offsides: 'Impedimentos',
      fouls: 'Faltas',
      yellowCards: 'Cartões Amarelos',
      redCards: 'Cartões Vermelhos',
      saves: 'Defesas',
      tackles: 'Desarmes',
      interceptions: 'Interceptações',
    },
    modal: {
      best: 'Melhor',
      record: 'Campanha',
      stage: 'Fase',
      bestPlayer: 'Melhor Jogador',
      signature: 'Partida Chave',
    },
    bracket: {
      pending: 'Pendente',
    },
  },
  mobile: {
    landing: { intro: 'Simulador Copa 2026', description: 'Do jogo de abertura à final, toque em Continuar para acompanhar toda a simulação da Copa do Mundo de 2026.', welcome: 'Bem-vindo ao seu próprio tempo de Copa do Mundo. Toque para simular rapidamente e prever quem levantará a taça. No PC também há modo treinador.', hiddenStart: 'Simular com equipes ocultas', start: 'Iniciar simulação', startTitle: 'Iniciar simulação agora', startSubtitle: 'Equipes reais, grupos reais e todos os jogos simulados como espectador em menos de dez minutos.', hiddenCheckbox: 'Permitir que Itália, Polônia, Indonésia, China e Emirados Árabes Unidos disputem a Copa' },
    topbar: { settings: 'Configurações' },
    tabs: { navigation: 'Navegação móvel', news: 'Notícias', fixtures: 'Jogos', standings: 'Tabela', knockout: 'Mata-mata', data: 'Dados' },
    action: { continue: 'Continuar', readNews: 'Ler notícias', simulateNext: 'Simular rodada', restart: 'Reiniciar', completed: 'Concluído' },
    settings: { title: 'Configurações', language: 'Idioma', restart: 'Reiniciar', restartConfirm: 'Reiniciar e apagar a simulação móvel atual?', close: 'Fechar configurações' },
    news: { previous: 'Anterior', next: 'Próxima', pcMore: 'Use a versão para PC para mais surpresas e funções.', empty: 'Sem notícias.' },
    fixtures: { previousDay: 'Rodada anterior', nextDay: 'Próxima rodada', noMatches: 'Sem jogos nesta rodada.' },
    standings: { groupStandings: 'Tabela dos grupos', knockout: 'Mata-mata', roundOf32: '32 avos', roundOf16: 'Oitavas', quarterFinal: 'Quartas', semiFinal: 'Semifinais', thirdPlace: '3º lugar', final: 'Final' },
    data: { goals: 'Artilharia', assists: 'Assistências', pcMore: 'Use a versão para PC para ver mais dados de jogadores e equipes.', empty: 'Sem dados.' },
    team: { squad: 'Elenco', fixtures: 'Jogos', tactic: 'Tática', close: 'Fechar equipe' },
  },
    teamNames: {

    mexico: 'México', south_africa: 'África do Sul', south_korea: 'Coreia do Sul',
    czechia: 'Tchéquia', canada: 'Canadá', bosnia_herzegovina: 'Bósnia e Herzegovina',
    switzerland: 'Suíça', qatar: 'Catar', brazil: 'Brasil', morocco: 'Marrocos',
    scotland: 'Escócia', haiti: 'Haiti', united_states: 'Estados Unidos',
    australia: 'Austrália', paraguay: 'Paraguai', turkiye: 'Turquia',
    germany: 'Alemanha', curacao: 'Curaçao', ivory_coast: 'Costa do Marfim',
    ecuador: 'Equador', netherlands: 'Países Baixos', japan: 'Japão',
    tunisia: 'Tunísia', sweden: 'Suécia', belgium: 'Bélgica', iran: 'Irã',
    egypt: 'Egito', new_zealand: 'Nova Zelândia', spain: 'Espanha',
    uruguay: 'Uruguai', saudi_arabia: 'Arábia Saudita', cape_verde: 'Cabo Verde',
    france: 'França', senegal: 'Senegal', norway: 'Noruega', iraq: 'Iraque',
    argentina: 'Argentina', austria: 'Áustria', algeria: 'Argélia',
    jordan: 'Jordânia', portugal: 'Portugal', colombia: 'Colômbia',
    uzbekistan: 'Uzbequistão', dr_congo: 'RD Congo', england: 'Inglaterra',
    croatia: 'Croácia', panama: 'Panamá', ghana: 'Gana',
    italy: 'Itália',
    tbd: 'TBD',
    china: 'China',

    indonesia: "Indonésia",
    united_arab_emirates: "EAU",
    poland: "Polónia",

  },
};
